'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHANGEHEADERNAVIGATIONTEXT = exports.NOTREQUIRELOGIN = exports.REQUIRELOGIN = exports.CHANGELOADINGTOFALSE = exports.CHANGELOADINGTOTRUE = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = info;
exports.changeToBlack = changeToBlack;
exports.changeToWhite = changeToWhite;
exports.changeLoadingToTrue = changeLoadingToTrue;
exports.changeLoadingToFalse = changeLoadingToFalse;
exports.changeToLoginFalse = changeToLoginFalse;
exports.changeHeaderText = changeHeaderText;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by lyj on 2016/4/18.
 */
var CHANGETOBLACK = 'goeasy-crafts/CHANGETOBLACK';
var CHANGETOWHITE = 'goeasy-crafts/CHANGETOWHITE';

var CHANGELOADINGTOTRUE = exports.CHANGELOADINGTOTRUE = 'goeasy-crafts/CHANGELOADINGTOTRUE';
var CHANGELOADINGTOFALSE = exports.CHANGELOADINGTOFALSE = 'goeasy-crafts/CHANGELOADINGTOFALSE';

var REQUIRELOGIN = exports.REQUIRELOGIN = 'goeasy-crafts/REQUIRELOGIN';
var NOTREQUIRELOGIN = exports.NOTREQUIRELOGIN = 'goeasy-crafts/NOTREQUIRELOGIN';

var CHANGEHEADERNAVIGATIONTEXT = exports.CHANGEHEADERNAVIGATIONTEXT = 'goeasy-crafts/CHANGEHEADERNAVIGATIONTEXT';

var initialState = {
  isBackGroundColorBlack: false,
  isLoading: false,
  toLogin: false,
  headerTxt: '艺品网首页'
};

function info() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case CHANGETOBLACK:
      return (0, _extends3.default)({}, state, {
        isBackGroundColorBlack: true
      });
    case CHANGETOWHITE:
      return (0, _extends3.default)({}, state, {
        isBackGroundColorBlack: false
      });
    case CHANGELOADINGTOTRUE:
      return (0, _extends3.default)({}, state, {
        isLoading: true
      });
    case CHANGELOADINGTOFALSE:
      return (0, _extends3.default)({}, state, {
        isLoading: false
      });
    case REQUIRELOGIN:
      return (0, _extends3.default)({}, state, {
        toLogin: true
      });
    case NOTREQUIRELOGIN:
      return (0, _extends3.default)({}, state, {
        toLogin: false
      });
    case CHANGEHEADERNAVIGATIONTEXT:
      return (0, _extends3.default)({}, state, {
        headerTxt: action.value
      });
    default:
      return state;
  }
}

function changeToBlack() {
  return {
    type: CHANGETOBLACK
  };
}
function changeToWhite() {
  return {
    type: CHANGETOWHITE
  };
}

function changeLoadingToTrue() {
  return {
    type: CHANGELOADINGTOTRUE
  };
}

function changeLoadingToFalse() {
  return {
    type: CHANGELOADINGTOFALSE
  };
}

function changeToLoginFalse() {
  return {
    type: NOTREQUIRELOGIN
  };
}

function changeHeaderText(value) {
  return {
    type: CHANGEHEADERNAVIGATIONTEXT,
    value: value
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/background.js
 ** module id = 15
 ** module chunks = 0
 **/